import React, { useEffect, useState } from "react";
import { Accordion, Card } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";

export default function Step5ATrackPleatedSheer({
  t,
  step3,
  step31,
  depSet,
  accordionActiveKey,
  requiredStep,
  stepSelectedLabel,
  pageLanguage,
  clearInputs,
  setCart,
  setDeps,
  step3ARodErr1,
  ContextAwareToggle,
  nameStep,
  step3ATrack,
  setStep3ATrack,
  inputs,
  NextStep,
  modals,
  modalHandleClose,
  setStep3B,
  finishedLengthTemp,
  step3A0,
  step3A,
  
  modalHandleShow,
  rodWidth
}) {
  const [step3AClick, setStep3AClick] = useState(null);
  const [checkedInputs, setCheckedInputs] = useState({
    "3ATrack1": false,
    "3ATrack2": false,
    "3ATrack3": false,
    "3ATrack4": false,
  });

  const [previousSelection, setPreviousSelection] = useState("");
  // UseEffect to update checked state based on step3ATrack value
  useEffect(() => {
    setCheckedInputs({
      "3ATrack1": step3ATrack === "Sill",
      "3ATrack2": step3ATrack === "Apron",
      "3ATrack3": step3ATrack === "Floor",
      "3ATrack4": step3ATrack === "Slight Puddle",
    });
  }, [step3ATrack]);



  // Function to handle radio change
  const handleRadioChange = (value, e) => {
    setStep3ATrack(value);
    setStep3AClick(e);
    setPreviousSelection(step3ATrack);
    if (
      (step3ATrack === "Sill") &&
      (value === "Floor" || value === "Slight Puddle" ||  value === "Apron")
    ) {
      if(rodWidth !== undefined){
        modalHandleShow("FinishedLengthWarning2");
      }else{
        clearInputs(e);
      }
    } else if (
      (step3ATrack === "Floor") &&
      (value === "Sill" || value === "Apron" || value === "Slight Puddle")
    ) {
      if(rodWidth !== undefined){
        modalHandleShow("FinishedLengthWarning2");
      }else{
        clearInputs(e);
      }
    } else if (
      (step3ATrack === "Slight Puddle") &&
      (value === "Sill" || value === "Apron" || value === "Floor")
    ) {
      if(rodWidth !== undefined){
        modalHandleShow("FinishedLengthWarning2");
      }else{
        clearInputs(e);
      }
    } else if (
      (step3ATrack === "Apron") &&
      (value === "Sill" || value === "Slight Puddle" || value === "Floor")
    ) {
      if(rodWidth !== undefined){
        modalHandleShow("FinishedLengthWarning2");
      }else{
        clearInputs(e);
      }
    } else  {
      clearInputs(e);
    }

    if (value === "Sill") {
      setCart(
        "FinishedLengthType",
        "Sill",
        "RodToFloor,Width3C,ExtensionLeft,ExtensionRight,Height3E,WindowToFloor,ShadeMount,CeilingToFloor,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3,CeilingToFloor1,CeilingToFloor2,CeilingToFloor3"
      );
      setDeps(
        "3BRod,3CRod,3DRod",
        "3ARod,3ATrack1,3CRodFloor,3B,3C,3D1,3D2,3E,3F,3G,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
      );
    } else if (value === "Apron") {
      setCart(
        "FinishedLengthType",
        "Apron",
        "RodToFloor,Width3C,ExtensionLeft,ExtensionRight,Height3E,WindowToFloor,ShadeMount,CeilingToFloor,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3,CeilingToFloor1,CeilingToFloor2,CeilingToFloor3"
      );
      setDeps(
        "3BRod,3CRod,3DRod",
        "3ARod,3ATrack1,3CRodFloor,3B,3C,3D1,3D2,3E,3F,3G,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
      );
    } else if (value === "Floor") {
      setCart(
        "FinishedLengthType",
        "Floor",
        "RodToBottom,Width3C,ExtensionLeft,ExtensionRight,Height3E,WindowToFloor,ShadeMount,CeilingToFloor,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3,CeilingToFloor1,CeilingToFloor2,CeilingToFloor3"
      );
      setDeps(
        "3BRod,3CRodFloor,3DRod",
        "3ARod,3ATrack1,3CRod,3B,3C,3D1,3D2,3E,3F,3G,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
      );
    } else if (value === "Slight Puddle") {
      setCart(
        "FinishedLengthType",
        "Slight Puddle",
        "RodToBottom,Width3C,ExtensionLeft,ExtensionRight,Height3E,WindowToFloor,ShadeMount,CeilingToFloor,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3,CeilingToFloor1,CeilingToFloor2,CeilingToFloor3"
      );
      setDeps(
        "3BRod,3CRodFloor,3DRod",
        "3ARod,3ATrack1,3CRod,3B,3C,3D1,3D2,3E,3F,3G,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
      );
    }
  };



  const revertToPreviousSelection = () => {
    if (previousSelection) {
      setStep3ATrack(previousSelection);
    }
  };

  return (
    <>
      <Card className={step3 === "true" && step31 === "Track" ? "" : "noDisplay"}>
        <Card.Header
          className={
            [...depSet].findIndex((el) => el.startsWith("3")) === -1 &&
            !accordionActiveKey.startsWith("3")
              ? "hidden"
              : ""
          }
        >
          <ContextAwareToggle
            eventKey="3A"
            stepNum={t(nameStep)}
            stepTitle={t("dk_step2A")}
            stepRef="3ARod"
            type="1"
            required={requiredStep["3ARod"]}
            stepSelected={
              stepSelectedLabel["3ARod"] === undefined ? "" : stepSelectedLabel["3ARod"]
            }
          />
        </Card.Header>
        <Accordion.Collapse eventKey="3A">
          <Card.Body>
            <div className="card_body card_body_radio card_body_finished_length card_body_finished_length_grommet">
              <div className="box100">
                <p className="step_selection_title">{t("dk_step2A_title")}</p>
              </div>
              <div className="box25 radio_style">
                <img
                  src={
                    pageLanguage === "fa"
                      ? require("../../Images/drapery/grommet/length type-05.svg").default
                      : require("../../Images/drapery/grommet/length type-04.svg").default
                  }
                  className="img-fluid height_auto"
                  alt=""
                />
                <input
                  className="radio"
                  type="radio"
                  text={t("Sill")}
                  value="1"
                  name="step3ATrack"
                  ref-num="3ARod"
                  id="3ATrack1"
                  checked={checkedInputs["3ATrack1"]}
                  onChange={(e) => handleRadioChange("Sill", e)}
                  ref={(ref) => (inputs.current["3ATrack1"] = ref)}
                />
                <label htmlFor="3ATrack1">{t("Sill")}</label>
              </div>
              <div className="box25 radio_style">
                <img
                  src={
                    pageLanguage === "fa"
                      ? require("../../Images/drapery/grommet/length type-06.svg").default
                      : require("../../Images/drapery/grommet/length type-03.svg").default
                  }
                  className="img-fluid height_auto"
                  alt=""
                />
                <input
                  className="radio"
                  type="radio"
                  text={t("Apron")}
                  value="2"
                  name="step3ATrack"
                  ref-num="3ARod"
                  id="3ATrack2"
                  checked={checkedInputs["3ATrack2"]}
                  onChange={(e) => handleRadioChange("Apron", e)}
                  ref={(ref) => (inputs.current["3ATrack2"] = ref)}
                />
                <label htmlFor="3ATrack2">{t("Apron")}</label>
              </div>
              <div className="box25 radio_style">
                <img
                  src={
                    pageLanguage === "fa"
                      ? require("../../Images/drapery/grommet/length type-07.svg").default
                      : require("../../Images/drapery/grommet/length type-02.svg").default
                  }
                  className="img-fluid height_auto"
                  alt=""
                />
                <input
                  className="radio"
                  type="radio"
                  text={t("Floor")}
                  value="3"
                  name="step3ATrack"
                  ref-num="3ARod"
                  id="3ATrack3"
                  checked={checkedInputs["3ATrack3"]}
                  onChange={(e) => handleRadioChange("Floor", e)}
                  ref={(ref) => (inputs.current["3ATrack3"] = ref)}
                />
                <label htmlFor="3ATrack3">{t("Floor")}</label>
              </div>
              <div className="box25 radio_style">
                <img
                  src={
                    pageLanguage === "fa"
                      ? require("../../Images/drapery/grommet/length type-08.svg").default
                      : require("../../Images/drapery/grommet/length type-01.svg").default
                  }
                  className="img-fluid height_auto"
                  alt=""
                />
                <input
                  className="radio"
                  type="radio"
                  text={t("Slight Puddle")}
                  value="4"
                  name="step3ATrack"
                  ref-num="3ARod"
                  id="3ATrack4"
                  checked={checkedInputs["3ATrack4"]}
                  onChange={(e) => handleRadioChange("Slight Puddle", e)}
                  ref={(ref) => (inputs.current["3ATrack4"] = ref)}
                />
                <label htmlFor="3ATrack4">{t("Slight Puddle")}</label>
              </div>

              <div
                className={
                  step3ATrack === "Apron"
                    ? step3ARodErr1
                      ? "secondary_options secondary_options_err secondary_options_text"
                      : "secondary_options secondary_options_text"
                    : "noDisplay"
                }
              >
                <div className="card-body-display-flex">
                  <div className="checkbox_style checkbox_style_step2">
                    <span className="checkbox_text box100">
                      {t("grommet_apron_checkbox_title")}
                    </span>
                  </div>
                </div>
              </div>

              <div
                className={
                  step3ATrack === "Slight Puddle"
                    ? "secondary_options secondary_options_text"
                    : "noDisplay"
                }
              >
                <div className="card-body-display-flex">
                  <div className="checkbox_style checkbox_style_step2">
                    <span className="checkbox_text box100">{t("puddle_text")}</span>
                  </div>
                </div>
              </div>
              {step3ARodErr1 && <div className="input_not_valid">{t("grommet_step3AErr1")}</div>}
              <NextStep currentStep="3ARod" eventKey="3B">
                {t("NEXT STEP")}
              </NextStep>
            </div>

            <div className="accordion_help">
              <div className="help_container">
                <div className="help_column help_left_column">
                  <p className="help_column_header"></p>
                  <ul className="help_column_list">
                    <li className="no_listStyle">
                      <b>{t("dk_step2a_help1")}</b>
                      {t("dk_step2a_help2")}
                    </li>
                    <li className="no_listStyle">
                      <b>{t("grommet_step3a_help2")}</b>
                      {t("grommet_step3a_help3")}
                    </li>
                    <li className="no_listStyle">
                      <b>{t("grommet_step3a_help4")}</b>
                      {t("grommet_step3a_help5")}
                    </li>
                    <li className="no_listStyle">
                      <b>{t("grommet_step3a_help6")}</b>
                      {t("grommet_step3a_help7")}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </Card.Body>
        </Accordion.Collapse>
      </Card>
      <Modal
        dialogClassName={`warning_modal2 bigSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={
          modals["FinishedLengthWarning2"] === undefined ? false : modals["FinishedLengthWarning2"]
        }
        onHide={() => modalHandleClose("FinishedLengthWarning2")}
      >
        <Modal.Header></Modal.Header>
        <Modal.Body>
          <p>{t("FinishedLengthWarning")}</p>

          <br />
          <div className="buttons_section">
            <button
              className="btn btn-new-dark"
              onClick={() => {
                revertToPreviousSelection();
                modalHandleClose("FinishedLengthWarning2");
              }}
            >
              {t("CANCEL")}
            </button>
            <button
              className="btn white_btn"
              onClick={() => {
                setStep3B(finishedLengthTemp.stepValue);
                clearInputs(step3AClick);
                modalHandleClose("FinishedLengthWarning2");
              }}
            >
              {t("I AGREE, CONTINUE ANYWAY")}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
